import React, { Fragment } from "react";

import { Container, Content, Question, Option } from "./Quiz.styles";
import { Header, Footer, Button } from "../../../Components";
import CircleOutlined from "@mui/icons-material/CircleOutlined";
import Check from "@mui/icons-material/Check";

import { SelectQuestionProps, QuestionStateProps } from "./Quiz.controller";

export interface QuizScreenProps {
  title: string;
  subtitle: string;

  loading: boolean;
  disabled: boolean;

  quiz: QuestionStateProps[];
  selectQuestion(selected: SelectQuestionProps): () => void;

  onSubmit(): Promise<void>;
}

export const QuizScreen: React.FC<QuizScreenProps> = ({
  title,
  subtitle,
  loading,
  disabled,
  quiz,
  selectQuestion,
  onSubmit,
}) => {
  return (
    <Container>
      <Header />
      <Content>
        <h1>{title}</h1>
        <p>{subtitle}</p>

        {quiz?.map((question) => (
          <Question key={question?.id}>
            <h2>{question?.question}</h2>

            {question?.options?.map((option, index) => (
              <Fragment key={`${question.id}-${option.text}-${option?.value}`}>
                <Option
                  selected={question?.valueSelectedQuestion === option?.value}
                  onClick={selectQuestion({
                    idQuestion: question.id,
                    valueOption: option.value,
                  })}
                >
                  {index === 0 && <div className="dash" />}
                  <div className="containerAnswer">
                    <p>{option.value}</p>
                    {question?.valueSelectedQuestion === option?.value ? (
                      <Check style={{ color: "#006BEE" }} />
                    ) : (
                      <CircleOutlined style={{ color: "#69769B" }} />
                    )}
                  </div>
                  <div className="dash" />
                </Option>
              </Fragment>
            ))}
          </Question>
        ))}

        <div className="centerButton">
          <Button onClick={onSubmit} disabled={disabled} loading={loading}>
            Finalizar
          </Button>
        </div>
      </Content>
      <Footer />
    </Container>
  );
};
